import { createSelector } from 'reselect';

import { selectIsCepikDataRejected } from 'app/store/data/shortPathData';
import { selectIsCepik3ShortPath } from 'app/store/data/quotation';

export const selectIsCepik3PathActive = createSelector(
  [selectIsCepik3ShortPath, selectIsCepikDataRejected],
  (isCepik3ShortPath, isCepikDataRejected) =>
    Boolean(isCepik3ShortPath && !isCepikDataRejected)
);
